import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

function loadBotLink(): Promise<void> {
	if (globalThis.__PRIME_BOT__ !== undefined) {
		return Promise.resolve()
	}

	return new Promise((resolve, reject) => {
		const script = document.createElement('script')
		script.src = '/bot-link.js'
		script.async = false
		script.onload = () => resolve()
		script.onerror = () => reject(new Error('Failed to load /bot-link.js'))
		document.head.appendChild(script)
	})
}

async function bootstrap() {
	await loadBotLink()

	const elem = document.getElementById('root')!
	const app = (
		<StrictMode>
			<App />
		</StrictMode>
	)

	if (import.meta.hot) {
		const root = (import.meta.hot.data.root ??= createRoot(elem))
		root.render(app)
	} else {
		createRoot(elem).render(app)
	}
}

bootstrap().catch(error => {
	console.error('Failed to bootstrap app:', error)
})
